import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { widthMixin } from '../mixins';

const CompactFooterContainer = styled.div`
  display: grid;
  width: auto;
  background: #f2f4f7;
  padding: 30px 0 50px 0;
`;

const CompactFooterContent = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-self: center;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 20px 0 0;
    padding: 0;
  }
  ${widthMixin};
`;

const CompactFooterLink = styled(Link)`
  text-decoration: none;
  color: #444;
`;

export { CompactFooterContainer, CompactFooterContent, CompactFooterLink };



// WEBPACK FOOTER //
// ./src/components/UI/CompactFooterUI.tsx